import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	marketing: {
		id: 'servicedesk-project-department-type-select.marketing',
		defaultMessage: 'Marketing',
		description: 'Department type select display value for Marketing',
	},
	hr: {
		id: 'servicedesk-project-department-type-select.hr',
		defaultMessage: 'Human Resources (HR) and People Teams',
		description: 'Department type select display value for Human Resources',
	},
	sales: {
		id: 'servicedesk-project-department-type-select.sales',
		defaultMessage: 'Sales',
		description: 'Department type select display value for Sales',
	},
	legal: {
		id: 'servicedesk-project-department-type-select.legal',
		defaultMessage: 'Legal',
		description: 'Department type select display value for Legal',
	},
	finance: {
		id: 'servicedesk-project-department-type-select.finance',
		defaultMessage: 'Finance',
		description: 'Department type select display value for Finance',
	},
	it: {
		id: 'servicedesk-project-department-type-select.it',
		defaultMessage: 'Information technology (IT)',
		description: 'Department type select display value for IT',
	},
	businessOperations: {
		id: 'servicedesk-project-department-type-select.business-operations',
		defaultMessage: 'Operations - Business',
		description: 'Department type select display value for Business Operations',
	},
	facilities: {
		id: 'servicedesk-project-department-type-select.facilities',
		defaultMessage: 'Facilities',
		description: 'Department type select display value for Facilities',
	},
	design: {
		id: 'servicedesk-project-department-type-select.design',
		defaultMessage: 'Design',
		description: 'Department type select display value for Design',
	},
	analytics: {
		id: 'servicedesk-project-department-type-select.analytics',
		defaultMessage: 'Data/analytics',
		description: 'Department type select display value for Data/analytics',
	},
	customerService: {
		id: 'servicedesk-project-department-type-select.customer-service',
		defaultMessage: 'Customer Service',
		description: 'Department type select display value for Customer Service',
	},
	software: {
		id: 'servicedesk-project-department-type-select.software',
		defaultMessage: 'Software Development',
		description: 'Department type select display value for Software Development',
	},
	manufacturing: {
		id: 'servicedesk-project-department-type-select.manufacturing',
		defaultMessage: 'Manufacturing',
		description: 'Department type select display value for Manufacturing',
	},
	riskAndCompliance: {
		id: 'servicedesk-project-department-type-select.risk-and-compliance',
		defaultMessage: 'Risk & Compliance',
		description: 'Department type select display value for Risk and compliance',
	},
	research: {
		id: 'servicedesk-project-department-type-select.research',
		defaultMessage: 'Research',
		description: 'Department type select display value for Research',
	},
	procurement: {
		id: 'servicedesk-project-department-type-select.procurement',
		defaultMessage: 'Procurement',
		description: 'Department type select display value for Procurement',
	},

	other: {
		id: 'servicedesk-project-department-type-select.other',
		defaultMessage: 'Other',
		description: 'Department type select display value for Other',
	},
	label: {
		id: 'servicedesk-project-department-type-select.label',
		defaultMessage: 'Team type',
		description: 'Label text for the department type select dialog.',
	},
	placeholder: {
		id: 'servicedesk-project-department-type-select.placeholder',
		defaultMessage: 'Select the type of team that will use this project',
		description: 'Placeholder text for the department type select dialog.',
	},
	footer: {
		id: 'servicedesk-project-department-type-select.footer',
		defaultMessage: 'This will help us personalize your project setup experience.',
		description: 'Disclaimer message explaining to the user why their input is being requested',
	},
	departmentFieldRequired: {
		id: 'servicedesk-project-department-type-select.department-field-required',
		defaultMessage: 'Choose a team type.',
		description:
			'Validation error message displayed if user tries to create a project without selecting a team type',
	},
	tooLongProjectTeamTypeError: {
		id: 'servicedesk-project-department-type-select.too-long-project-team-type-error',
		defaultMessage: "Project team type can't exceed {maxCharacters} characters.",
		description:
			'Error message that is shown when the project team type free text field exceeds the maximum number of allowed characters',
	},
});
